import {
  ScreenHeaderButton,
  ScreenHeaderContainer,
  ScreenHeaderContent,
  ScreenHeaderDisclaimer,
  ScreenHeaderEyebrow,
  ScreenHeaderLocationButton,
  ScreenHeaderPointsButton,
  ScreenHeaderScanButton,
  ScreenHeaderTitle,
  ScreenHeaderTitleContainer,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const ScreenHeader = {
  Container: ScreenHeaderContainer,
  Content: ScreenHeaderContent,
  Eyebrow: ScreenHeaderEyebrow,
  Title: ScreenHeaderTitle,
  TitleContainer: ScreenHeaderTitleContainer,
  LocationButton: ScreenHeaderLocationButton,
  Button: ScreenHeaderButton,
  PointsButton: ScreenHeaderPointsButton,
  ScanButton: ScreenHeaderScanButton,
  Disclaimer: ScreenHeaderDisclaimer,
};
